module.exports = __webpack_public_path__ + "img/IMG_8981_L_Foamcore.fe163511.jpg";